<template>
  <el-dialog :close-on-click-modal="false" v-dialogDrag :title="title" :visible.sync="detailDialogVisible" width="80%" append-to-body :before-close="handleClose">
    <el-form :model="form" inline label-width="100px">
      <el-form-item label="还款单号:">
        <div class="form-width-xxs">
          {{form.repayNum}}
        </div>
      </el-form-item>
      <el-form-item label="还款时间:">
        <div class="form-width-xxs text-out" :title="form.repayDate">
          {{form.repayDate}}
        </div>
      </el-form-item>
      <el-form-item label="会员名字:">
        <div class="form-width-xxs">
          {{form.memberName}}
        </div>
      </el-form-item>
      <el-form-item label="手机号码:">
        <div class="form-width-xxs">
          {{form.mobilePhone}}
        </div>
      </el-form-item>
      <el-form-item label="补单日期:" v-if="form.additionDate&&form.isAddition==1">
        <div class="form-width-xxs">
          {{form.additionDate}}
        </div>
      </el-form-item>
    </el-form>
    <el-table :data="form.repayTradeLists" row-key="index" :row-class-name="rowClassName" :expand-row-keys="expandRowKeys" :row-key="getRowKey" @expand-change="handleExpandChange" ref="list" :header-cell-style="{background: 'linear-gradient(#6cb3ff, #1873d4)' ,color:'#eeeeee'}">
      <el-table-column type="expand">
        <template slot-scope="props">
          <div style="width:920px;overflow: hidden;" class="border-radius-10 border padding-xs bg-white margin-bottom-xs">
            <el-table :data="props.row.repayAccountListRequests" :summary-method="getSummaries" show-summary>
              <el-table-column align="center" prop="accountNum" show-overflow-tooltip label="帐户编码" min-width="100"></el-table-column>
              <el-table-column align="center" prop="accountName" show-overflow-tooltip label="帐户名称" min-width="100"></el-table-column>
              <el-table-column align="center" prop="accountName" label="帐户类型" min-width="80">
                <template slot-scope="scope">
                  {{scope.row.accountType==0?'充值':'疗程'}}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="payNumber" label="支付次数" min-width="75">
                <template slot-scope="scope">
                  {{scope.row.payNumber?scope.row.payNumber:'--'}}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="payMoney" label="支付金额" min-width="75"></el-table-column>
              <el-table-column align="center" prop="storeNum" show-overflow-tooltip label="门店编码" min-width="100"></el-table-column>
              <el-table-column align="center" prop="storeName" show-overflow-tooltip label="门店名称" min-width="100"></el-table-column>
            </el-table>
          </div>
          <div class="flex justify-start align-start flex-wrap" @click="rowIndex = props.$index">
            <staffsles :ref="'staffsles'+props.$index" @staffslesData="staffslesData"></staffsles>
            <admin :ref="'admin'+props.$index" @adminData="adminData"></admin>
            <manager :ref="'manager'+props.$index" @managerData="managerData"></manager>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="docNum" label="单号" min-width="120"></el-table-column>
      <el-table-column align="center" prop="tradeName" label="名称" min-width="120"></el-table-column>
      <el-table-column align="center" prop="docType" label="类别" min-width="120">
        <template slot-scope="scope">
          <div v-show="scope.row.docType=='card_recharge'">充值单</div>
          <div v-show="scope.row.docType=='card_use'">疗程单</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="tradeMoney" label="成交额" min-width="120"></el-table-column>
      <el-table-column align="center" prop="debtMoney" label="待付金额" min-width="120"></el-table-column>
      <el-table-column align="center" prop="payRechargeMoney" label="卡付" min-width="120"></el-table-column>
      <el-table-column align="center" prop="repayMoney" label="现付" min-width="120"></el-table-column>
      <el-table-column align="center" prop="payMoney" label="实付金额" min-width="120"></el-table-column>
    </el-table>
    <div style="width:280px" class="border-radius-10 border  padding-xs bg-white">
      <el-table :data="form.payLists" :summary-method="getSummaries" show-summary :header-cell-style="{background: 'linear-gradient(#6cb3ff, #1873d4)' ,color:'#eeeeee'}">
        <!-- <el-table-column align="center" prop="payName" label="支付方式" min-width="100"></el-table-column> -->
        <el-table-column align="center" prop="payId" label="支付方式" min-width="100">
          <template slot-scope="scope">
            <el-select v-model="scope.row.payId" placeholder="请选择">
              <el-option
                v-for="item in optionsT"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="payMoney" label="支付金额" min-width="120"></el-table-column>
      </el-table>
    </div>
    <!-- <detail ref="detail" @detailData="detailData"></detail> -->
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="handleClose">取消</el-button>
      <el-button size="mini" v-if="title=='修改'" type="primary" plain @click="confirm()">修改</el-button>
    </span>
  </el-dialog>
</template>
<script>
import detail from "./detail";
import admin from "@/components/staffList/admin/index";
import manager from "@/components/staffList/manager/index";
import staffsles from "@/components/staffList/staff/index";
import { repayEditStaff, selectOne,ctlist } from "@/api/eashier.js";
export default {
  components: {
    staffsles,
    manager,
    admin,
    detail,
  },
  data() {
    return {
      detailDialogVisible: false,
      title: "", //弹窗标题
      form: {}, //主对象
      staffLists: [{ brandNumber: "", staffName: "", ratio: 100 }],
      managerList: [{ brandNumber: "", staffName: "", ratio: 100 }],
      adminList: [{ brandNumber: "", staffName: "", ratio: 100 }],
      rowIndex: -1, //选中打开的下标
      getRowKey(row) {
        return row.id; // 返回当前行id
      },
      expandRowKeys: [],
      optionsT:[]
    };
  },
  created(){
    this.init()
  },
  methods: {
    init(){
      ctlist({
        state: 1
      }).then(res=>{
        this.optionsT = res.rows.map(item=>{
          return {
            value:item.id,
            label:item.collectionTypeName
          }
        })
      })
    },
    handleExpandChange(row){
      this.rowClicks(row,row.index)
    },
    //关闭弹窗前的回调方法
    handleClose() {
      this.form = Object.assign({});
      this.detailDialogVisible = false;
      // this.$emit("detailData");
    },
    rowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    //员工占比返回方法
    staffslesData(v) {
      this.form.repayTradeLists[this.rowIndex].entities = [...v];
    },
    //高管占比返回方法
    managerData(v) {
      this.form.repayTradeLists[this.rowIndex].managerList = [...v];
    },
    //管理员占比返回方法
    adminData(v) {
      this.form.repayTradeLists[this.rowIndex].adminList = [...v];
    },
    //组件传值
    show(form, title) {
      if (title == "明细") {
        this.title = title;
      } else {
        this.title = "修改";
      }
      this.form = form;
      console.log(form)
      // if (form.repayTradeLists.length == 1) {
        this.rowIndex = 0;
        form.repayTradeLists.forEach((item, index) => {
          item.index = index;
          this.rowClick(form.repayTradeLists[index],index);
        });
      // }
      form.repayTradeLists.forEach((item) => {
        item.additionDate = form.additionDate;
        item.isAddition = form.isAddition;
      });
      this.detailDialogVisible = true;
    },
    rowClicks(row,index) {
      this.rowIndex = row.index;
      row.entities.forEach((item) => {
        item.staffName = item.saleStaffName;
        item.id = item.saleStaffId;
        item.identityCard = item.saleIdentityCard;
        item.ratio = item.saleRatio;
        item.staffNames = item.brandNumber + "--" + item.staffName;
      });
      selectOne({ type: 7, orderId: row.id }).then((res) => {
        if (res.code == "000000") {
          let managerList = [];
          let adminList = [];
          res.rows.forEach((item) => {
            if (item.staffType == 0) {
              item.staffNames = item.brandNumber + "--" + item.staffName;
              managerList.push(item);
            }
            if (item.staffType == 1) {
              item.staffNames = item.brandNumber + "--" + item.staffName;
              adminList.push(item);
            }
          });
          if (managerList.length == 0) {
            managerList.push({ ratio: 100 });
          }
          if (adminList.length == 0) {
            adminList.push({ ratio: 100 });
          }
          if (row.entities.length == 0) {
            row.entities.push({ ratio: 100 });
          }
          row.managerList = managerList;
          row.adminList = adminList;
          var that = this;
          setTimeout(() => {
            that.$refs['staffsles'+index].show(row.entities);
            that.$refs['manager'+index].show(row.managerList);
            that.$refs['admin'+index].show(row.adminList);
          }, 500);
        } else {
          this.$alert(res.message, "加载门店高管", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
    rowClick(row,index) {
      this.rowIndex = row.index;
      console.log('row--->',row)
      if(row.entities.length){
        row.entities.forEach((item) => {
          item.staffName = item.saleStaffName;
          item.id = item.saleStaffId;
          item.identityCard = item.saleIdentityCard;
          item.ratio = item.saleRatio;
          item.staffNames = item.brandNumber + "--" + item.staffName;
        });
      }
      selectOne({ type: 7, orderId: row.id }).then((res) => {
        if (res.code == "000000") {
          let managerList = [];
          let adminList = [];
          res.rows.forEach((item) => {
            if (item.staffType == 0) {
              item.staffNames = item.brandNumber + "--" + item.staffName;
              managerList.push(item);
            }
            if (item.staffType == 1) {
              item.staffNames = item.brandNumber + "--" + item.staffName;
              adminList.push(item);
            }
          });
          if (managerList.length == 0) {
            managerList.push({ ratio: 100 });
          }
          if (adminList.length == 0) {
            adminList.push({ ratio: 100 });
          }

          if (row.entities.length == 0) {
            row.entities.push({ ratio: 100 });
          }
          row.managerList = managerList;
          row.adminList = adminList;
          var that = this;
          setTimeout(() => {
            console.log('row.entities--->',row.entities)
            that.$refs['staffsles'+index].show(row.entities);
            that.$refs['manager'+index].show(row.managerList);
            that.$refs['admin'+index].show(row.adminList);
          }, 500);
        } else {
          this.$alert(res.message, "加载门店高管", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
    confirm() {
      this.form.repayTradeLists.forEach((item) => {
        let entities = [];
        item.entities.forEach((items) => {
          delete items.type;
          if (items.id) {
            entities.push(items);
          }
        });
        let salesmens = [];
        item.managerList.forEach((items) => {
          if (items.id) {
            items.staffType = 0;
            salesmens.push(items);
          }
        });
        item.adminList.forEach((items) => {
          if (items.id) {
            items.staffType = 1;
            salesmens.push(items);
          }
        });
        item.salesmens = salesmens;
        item.staffRequests = entities;
        item.payLists = this.form.payLists
      });
      repayEditStaff(this.form.repayTradeLists).then((res) => {
        if (res.code == "000000") {
          this.$message.success({ message: res.message });
          this.$emit("detailData");
          this.detailDialogVisible = false;
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
    //明细返回方法
    detailData(v) {
      this.detailDialogVisible = false;
      this.$emit("detailData");
    },
    detailEditStaff(row) {
      row.isCancel = this.form.isCancel;
      this.$refs.detail.show(row);
    },
    //指定列求和
    //数组按对应字段合计返回方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property == "spendMoney") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              sums[index] = "--";
            }
          }, 0);
          sums[index] += " ";
        } else if (column.property == "payMoney") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              sums[index] = "--";
            }
          }, 0);
          sums[index] += " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/eashier/repayment/components/index.vue